import { render } from "./SortCodeInput.vue?vue&type=template&id=28e5d58e&scoped=true"
import script from "./SortCodeInput.vue?vue&type=script&lang=js"
export * from "./SortCodeInput.vue?vue&type=script&lang=js"

import "./SortCodeInput.vue?vue&type=style&index=0&id=28e5d58e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e5d58e"]])

export default __exports__